const transactionCountReport = {
  transaction_count_report: "Informe de transacciones",
  all_accounts: "Todas las cuentas",
  account: "Cuenta",
  year: "Año",
  month: "Mes",
  period: "Período",
  bank: "Banco",
  iban: "IBAN",
  account_name: "Nombre de la cuenta",
  total_credit_transactions: "Transacciones de crédito total",
  total_debit_transactions: "Transacciones de débito total",
  total_transactions: "Total de transacciones",
  report_range_exceeds_6_months:
    "El rango seleccionado no puede superar 6 meses calendario. Ajusta las fechas.",
  no_data_available: "No hay datos disponibles",
  export_csv: "Exportar CSV",
  start_date: "Fecha de inicio",
  end_date: "Fecha de fin",
  start_date_required: "La fecha de inicio es obligatoria",
  end_date_required: "La fecha de fin es obligatoria",
  end_date_before_start_date: "La fecha de fin no puede ser anterior a la fecha de inicio",
  filter_by: "Filtrar por",
  search: "Buscar",
};

export default transactionCountReport;
